import http from '@/plugin/axios'
import Detail from '@utils/detail'
import Table from '@utils/table'

const table = new Table('orderpurchase.outorderissue')
  .type('index')
  .sortable(false)
  .add('goodsNo')
  .add('goodsName')
  .add('spec')
  .add('unitNo').format(data => `${data.row.unitNo}-${data.row.unitName}`)
  .add('collectQty')
  .label('needsAmount')
  .add('collectedQty')
  .label('usedAmount')
  .add('unCollectQty')
  .label('unreceivedAmount')
  .add('materialNo')
  .label('issueNo')
  .add('materialDate')
  .label('documentDate')
  .add('materialQty')
  .label('issueQty')

async function getData(data: any) {
  const list: any = await http({
    url: '/srmPurWorkorder/getWorkorderBody',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { workorderNos: [data.row.workorderNo] }
  })
  return {
    ...data.row,
    list: list[0].workorderRspList,
    spec: data.row.list[0].spec,
    goodsName: data.row.list[0].goodsName
  }
}

const header = {
  props: ['data'],
  render(this: any, h: any) {
    return h('div', [
      `${this.$t('orderpurchase.outorderissue.purchaseNo')}: ${
        this.data.purchaseNo
      }`
    ])
  }
}

export default new Detail('orderpurchase.outorderissue')
  .dTitle(header)
  .getData(getData)
  .title('detailTitle')
  .add('workorderNo').label('docNo')
  .add('outputQty').label('expectedAmount')
  .add('collectedSetsQty').label('numCollars')
  .add('productGoodsNo').label('finishedGoodsNo')
  .add('productGoodsName')
  .add('productSpec')
  .add('productUnitNo').format(data => `${data.row.productUnitNo}-${data.row.productUnitName}`)
  .addGroup('listTitle')
  .table('list', table)
